export const illegalUrls = [
  "ajanvaraus",
  "booking",
  "lahjakortti",
  "lahjakortit",
  "giftcard",
  "giftcards",
  "carte-cadeau",
  "cartes-cadeaux",
  "sarjakortti",
  "sarjakortit",
  "prepaidcards",
  "prepaidcard",
  "osta",
  "buy",
  "kauppa",
  "shop",
  "app",
  "sadmin",
  "clear-state",
  "test",
  "booking",
  "booking-month-view",
  "booking-cal-view",
  "booking-day-cal-view",
  "booking-week-cal-view",
  "booking-nextav-view",
  "booking-wizard",
  "booking-button",
  "website",
  "asiakkaat",
  "asiakas",
  "customers",
  "customer",
  "allocations",
  "account",
  "account-general",
  "account-privacy",
  "account-users",
  "account-billing",
  "settings",
  "settings-generic",
  "settings-appearance",
  "settings-booking",
  "settings-offices",
  "settings-resources",
  "settings-assets",
  "settings-services",
  "settings-membership",
  "settings-website",
  "settings-embed",
  "settings-payments",
  "settings-giftcard",
  "settings-giftcards",
  "settings-advanced",
  "settings-customer-segment",
  "dashboard",
  "statistics",
  "reports",
  "user",
  "logout",
  "view-record",
  "viewrecord",
  "viewEvent",
  "viewsubscriptions",
  "paymentcheck",
  "redirect",
  "payment",
  "payments",
  "massage",
  "classic-massage",
  "physiotherapy",
  "osteopathy",
  "acupuncture",
  "foot-therapy",
  "sports-massage",
  "maternity-massage",
  "occlusal-massage",
  "infant-massage",
  "dry-needling",
  "inbody-body-composition-analyzis",
  "neurosonic-treatment",
  "lpg-treatment",
  "therapy",
  "craniosacral-therapy",
  "brief-psychotherapy",
  "couple-therapy",
  "psychologist-reception",
  "psychotherapy",
  "psychiatrist-reception",
  "sex-therapy",
  "nutrition-therapy",
  "solution-focused-therapy",
  "speech-therapy",
  "music-therapy",
  "mobilisation-treatment",
  "hot-stone-massage",
  "shiatsu-massage",
  "indian-head-massage",
  "kalevala-mobilisation-treatment",
  "reflexology",
  "singing-bowl-therapy",
  "energy-healing",
  "homeopathy",
  "head-massage",
  "aromatic-therapy",
  "fascia-therapy",
  "naprapathy",
  "chiropractic",
  "lymphotherapy",
  "kinesio-taping",
  "reiki-treatment",
  "hieronta",
  "klassinen-hieronta",
  "fysioterapia",
  "osteopatia",
  "akupunktio",
  "jalkaterapia",
  "urheilu-hieronta",
  "raskausaika-hieronta",
  "purentalihas-hieronta",
  "vauvahieronta",
  "kuivaneulaus",
  "inbody-kehonkoostumusmittaus",
  "neurosonic-hoito",
  "lpg-hoito",
  "terapia",
  "kraniosakraaliterapia",
  "lyhytterapia",
  "paripsykoterapia",
  "psykologin-vastaanotto",
  "psykoterapia",
  "psykiatrin vastaanotto",
  "seksuaaliterapia-ja-neuvonta",
  "ravitsemusterapia",
  "ratkaisukeskeinen-terapia",
  "puheterapia",
  "musiikkiterapia",
  "jäsenkorjaus",
  "kuumakivihieronta",
  "shiatsu-hieronta",
  "intialainen-päähieronta",
  "kalevalainen-jäsenkorjaus",
  "vyohyketerapia",
  "aanimaljarentoutus",
  "energiahoito",
  "homeopatia",
  "paa-hieronta",
  "aromaterapia",
  "faskia-kasittely",
  "naprapatia",
  "kiropraktia",
  "lymfaterapia",
  "kinesioteippaus",
  "reikihoito",
  "helvetti",
  "kyrpä",
  "paska",
  "vittu",
  "perkele",
  "perse",
  "saatana",
  "jumalauta",
  "homo",
  "huora",
  "narttu",
  "neekeri",
  "pillu",
  "2girls1cup",
  "2g1c",
  "4r5e",
  "5h1t",
  "5hit",
  "5ht",
  "666",
  "@$$",
  "ass",
  "asshole",
  "a55",
  "a55hole",
  "a_s_s",
  "abbo",
  "abeed",
  "abuse",
  "acrotomophilia",
  "aeolus",
  "africoon",
  "ahole",
  "alabamahotpocket",
  "alaskanpipeline",
  "alligatorbait",
  "alligatorbait",
  "amcik",
  "anal",
  "analannie",
  "analprobe",
  "analsex",
  "andskota",
  "anilingus",
  "anus",
  "apeshit",
  "ar5e",
  "arabush",
  "arabushs",
  "areola",
  "areole",
  "argie",
  "armo",
  "armos",
  "aroused",
  "arrse",
  "arschloch",
  "arse",
  "arsehole",
  "aryan",
  "ash0le",
  "ash0les",
  "asholes",
  "assmonkey",
  "ass",
  "ass-fucker",
  "ass-hat",
  "ass-pirate",
  "assbag",
  "assbagger",
  "assbandit",
  "assbang",
  "assbanged",
  "assbanger",
  "assbangs",
  "assbite",
  "assblaster",
  "assclown",
  "asscock",
  "asscowboy",
  "asscracker",
  "asses",
  "assface",
  "assfuck",
  "assfucker",
  "assfukka",
  "assgoblin",
  "assh0le",
  "assh0lez",
  "asshat",
  "asshead",
  "assho1e",
  "asshole",
  "assholes",
  "assholz",
  "asshopper",
  "asshore",
  "assjacker",
  "assjockey",
  "asskiss",
  "asskisser",
  "assklown",
  "asslick",
  "asslicker",
  "asslover",
  "assman",
  "assmaster",
  "assmonkey",
  "assmunch",
  "assmuncher",
  "assnigger",
  "asspacker",
  "asspirate",
  "asspuppies",
  "assrammer",
  "assranger",
  "assshit",
  "assshole",
  "asssucker",
  "asswad",
  "asswhole",
  "asswhore",
  "asswipe",
  "asswipes",
  "autoerotic",
  "autoerotic",
  "ayir",
  "azazel",
  "azz",
  "azzhole",
  "bastard",
  "bitch",
  "boob",
  "b!+ch",
  "b!tch",
  "b!tchin",
  "b*tch",
  "b00b",
  "b00bies",
  "b00biez",
  "b00bs",
  "b00bz",
  "b17ch",
  "b1tch",
  "b7ch",
  "babeland",
  "babes",
  "babybatter",
  "babyjuice",
  "backdoor",
  "backdoorman",
  "badfuck",
  "bagging",
  "ballgag",
  "ballgravy",
  "ballkicking",
  "balllicking",
  "ballsack",
  "ballsucking",
  "ballbag",
  "balllicker",
  "ballsack",
  "bampot",
  "bangbro",
  "bangbros",
  "bangbus",
  "banger",
  "banging",
  "bareback",
  "barelylegal",
  "barelylegal",
  "barenaked",
  "barf",
  "barface",
  "barfface",
  "bassterd",
  "bassterds",
  "bastard",
  "bastardo",
  "bastards",
  "bastardz",
  "basterds",
  "basterdz",
  "bastinado",
  "bawdy",
  "bazongas",
  "bazooms",
  "bbw",
  "bdsm",
  "beaner",
  "beaners",
  "beaney",
  "beaneys",
  "beardedclam",
  "beastality",
  "beastial",
  "beastiality",
  "beastility",
  "beatch",
  "beatoff",
  "beatyourmeat",
  "beavercleaver",
  "beaverlips",
  "beefcurtains",
  "beeyotch",
  "bellend",
  "beotch",
  "bestial",
  "bestiality",
  "bicurious",
  "bi+ch",
  "bi7ch",
  "biatch",
  "bicurious",
  "bigblack",
  "bigbreasts",
  "bigknockers",
  "bigtits",
  "bigass",
  "bigbastard",
  "bigbreasts",
  "bigbutt",
  "bigtits",
  "bimbo",
  "bimbos",
  "bint",
  "birdlock",
  "bitch",
  "bitchass",
  "bitched",
  "bitcher",
  "bitchers",
  "bitches",
  "bitchez",
  "bitchin",
  "bitching",
  "bitchslap",
  "bitchtit",
  "bitchy",
  "biteme",
  "bitties",
  "blackcock",
  "blackcock",
  "blackman",
  "blackout",
  "blacks",
  "blondeaction",
  "blondeonblondeaction",
  "blondeonblonde",
  "bloodclaat",
  "bloody",
  "blowj",
  "blowjob",
  "blowyourl",
  "blowyourload",
  "blowjob",
  "blowjobs",
  "bluewaffle",
  "bluegum",
  "bluegums",
  "blumpkin",
  "boob",
  "boobs",
  "boang",
  "boche",
  "boches",
  "bodily",
  "boffing",
  "bogan",
  "bohunk",
  "boink",
  "boiolas",
  "bollick",
  "bollock",
  "bollocks",
  "bollok",
  "bollox",
  "bombers",
  "bombing",
  "bomd",
  "bondage",
  "boned",
  "boner",
  "boners",
  "bong",
  "bookie",
  "boong",
  "boonga",
  "boongas",
  "boongs",
  "boonie",
  "boonies",
  "booobs",
  "boooobs",
  "booooobs",
  "booooooobs",
  "bootee",
  "bootlip",
  "bootlips",
  "boozer",
  "boozy",
  "bosch",
  "bosche",
  "bosches",
  "boschs",
  "bosomy",
  "bountybar",
  "bountybars",
  "bountybar",
  "brea5t",
  "breastjob",
  "breastlover",
  "breastman",
  "brownshower",
  "brownshowers",
  "brunetteaction",
  "btch",
  "buceta",
  "buddhahead",
  "buddhaheads",
  "buffies",
  "bugger",
  "buggered",
  "buggery",
  "bukake",
  "bukkake",
  "bullcrap",
  "bulldike",
  "bulldyke",
  "bulletvibe",
  "bullshit",
  "bullshits",
  "bullshitted",
  "bullturds",
  "bumblefuck",
  "bumfuck",
  "bunghole",
  "bung",
  "bunga",
  "bungas",
  "bunghole",
  "bunnyfucker",
  "burrhead",
  "burrheads",
  "burrhead",
  "burrheads",
  "butchbabes",
  "butchdike",
  "butchdyke",
  "buttplug",
  "butt-pirate",
  "buttbang",
  "buttcheeks",
  "buttface",
  "buttfuck",
  "buttfucker",
  "buttfuckers",
  "butthead",
  "butthole",
  "buttman",
  "buttmuch",
  "buttmunch",
  "buttmuncher",
  "buttpirate",
  "buttplug",
  "buttstain",
  "buttwipe",
  "byatch",
  "cunt",
  "c-0-c-k",
  "c-o-c-k",
  "c-u-n-t",
  "c.0.c.k",
  "c.o.c.k.",
  "c.u.n.t",
  "c0ck",
  "c0cks",
  "c0cksucker",
  "c0k",
  "cabron",
  "caca",
  "cacker",
  "cahone",
  "cameljockey",
  "cameljockeys",
  "cameltoe",
  "cameljockey",
  "cameltoe",
  "camgirl",
  "camslut",
  "camwhore",
  "carpetmuncher",
  "carpetmuncher",
  "carruth",
  "cawk",
  "cawks",
  "cazzo",
  "cervix",
  "chav",
  "cheeseeatingsurrendermonkey",
  "cheeseeatingsurrendermonkies",
  "cheeseeatingsurrendermonkey",
  "cheeseeatingsurrendermonkies",
  "cheesehead",
  "cheeseheads",
  "cherrypopper",
  "chickslick",
  "chinaswede",
  "chinaswedes",
  "chinaman",
  "chinamen",
  "chinaswede",
  "chinaswedes",
  "chinc",
  "chincs",
  "chingchong",
  "chingchongs",
  "chinga",
  "chingchong",
  "chingchongs",
  "chink",
  "chinks",
  "chinky",
  "choad",
  "chocolaterosebuds",
  "chode",
  "chodes",
  "chonkies",
  "chonky",
  "chonkys",
  "chraa",
  "christkiller",
  "christkillers",
  "chug",
  "chugs",
  "chuj",
  "chunger",
  "chungers",
  "chunkies",
  "chunkys",
  "chute",
  "cipa",
  "circlejerk",
  "cl1t",
  "clamdigger",
  "clamdiver",
  "clamps",
  "clansman",
  "clansmen",
  "clanswoman",
  "clanswomen",
  "clevelandsteamer",
  "clit",
  "clitface",
  "clitfuck",
  "clitoris",
  "clitorus",
  "clits",
  "clitty",
  "clogwog",
  "cloverclamps",
  "clusterfuck",
  "cnts",
  "cntz",
  "cnut",
  "cocain",
  "cocaine",
  "cock",
  "cock-head",
  "cock-sucker",
  "cockbite",
  "cockblock",
  "cockblocker",
  "cockburger",
  "cockcowboy",
  "cockface",
  "cockfight",
  "cockfucker",
  "cockhead",
  "cockholster",
  "cockjockey",
  "cockknob",
  "cockknocker",
  "cockknoker",
  "cocklicker",
  "cocklover",
  "cockmaster",
  "cockmongler",
  "cockmongruel",
  "cockmonkey",
  "cockmunch",
  "cockmuncher",
  "cocknob",
  "cocknose",
  "cocknugget",
  "cockqueen",
  "cockrider",
  "cocks",
  "cockshit",
  "cocksman",
  "cocksmith",
  "cocksmoker",
  "cocksucer",
  "cocksuck",
  "cocksucked",
  "cocksucker",
  "cocksucking",
  "cocksucks",
  "cocksuka",
  "cocksukka",
  "cocktease",
  "cocky",
  "cohee",
  "coital",
  "coitus",
  "cok",
  "cokmuncher",
  "coksucka",
  "commie",
  "condom",
  "coochie",
  "coochy",
  "coolie",
  "coolies",
  "cooly",
  "coonass",
  "coonasses",
  "coonass",
  "coonasses",
  "coondog",
  "coons",
  "cooter",
  "coprolagnia",
  "coprophilia",
  "copulate",
  "corksucker",
  "cornhole",
  "cra5h",
  "crabs",
  "crackcocain",
  "cracker",
  "crackpipe",
  "crackwhore",
  "crap",
  "crapola",
  "crapper",
  "crappy",
  "creampie",
  "crotch",
  "crotchjockey",
  "crotchmonkey",
  "crotchrot",
  "cuck",
  "cumface",
  "cumlicker",
  "cum",
  "cumbubble",
  "cumdumpster",
  "cumfest",
  "cumguzzler",
  "cuming",
  "cumjockey",
  "cumlickr",
  "cumm",
  "cummer",
  "cummin",
  "cumming",
  "cumquat",
  "cumqueen",
  "cums",
  "cumshot",
  "cumshots",
  "cumslut",
  "cumstain",
  "cumsucker",
  "cumtart",
  "cunilingus",
  "cunillingus",
  "cunn",
  "cunnie",
  "cunnilingus",
  "cunntt",
  "cunny",
  "cunt",
  "cunteyed",
  "cuntface",
  "cuntfuck",
  "cuntfucker",
  "cunthole",
  "cunthunter",
  "cuntlick",
  "cuntlicker",
  "cuntlicking",
  "cuntrag",
  "cunts",
  "cuntslut",
  "cuntsucker",
  "cuntz",
  "currymuncher",
  "currymunchers",
  "currymuncher",
  "currymunchers",
  "cushi",
  "cushis",
  "cyalis",
  "cyberfuc",
  "cyberfuck",
  "cyberfucked",
  "cyberfucker",
  "cyberfuckers",
  "cyberfucking",
  "cybersex",
  "cyberslimer",
  "d0ng",
  "d0uch3",
  "d0uche",
  "d1ck",
  "d1ld0",
  "d1ldo",
  "d4mn",
  "dago",
  "dagos",
  "dahmer",
  "damm",
  "dammit",
  "damn",
  "damnation",
  "damned",
  "damnit",
  "darkey",
  "darkeys",
  "darkie",
  "darkies",
  "darky",
  "daterape",
  "daterape",
  "datnigga",
  "dawgiestyle",
  "dawgie-style",
  "daygo",
  "deapthroat",
  "deepthroat",
  "deepthroating",
  "deepaction",
  "deepthroat",
  "deepthroating",
  "defecate",
  "deggo",
  "dego",
  "degos",
  "demon",
  "dendrophilia",
  "destroyyourpussy",
  "deth",
  "diaperdaddy",
  "diaperhead",
  "diaperheads",
  "diaperdaddy",
  "diaperhead",
  "diaperheads",
  "dickpic",
  "dick",
  "dick-ish",
  "dickbag",
  "dickbeater",
  "dickbeaters",
  "dickbrain",
  "dickdipper",
  "dickface",
  "dickflipper",
  "dickforbrains",
  "dickfuck",
  "dickhead",
  "dickheads",
  "dickhole",
  "dickish",
  "dickjuice",
  "dickless",
  "dicklick",
  "dicklicker",
  "dickman",
  "dickmilk",
  "dickmonger",
  "dickpic",
  "dickripper",
  "dicks",
  "dicksipper",
  "dickslap",
  "dickslicker",
  "dicksucker",
  "dickwad",
  "dickweasel",
  "dickweed",
  "dickwhipper",
  "dickwod",
  "dickzipper",
  "diddle",
  "dike",
  "dild0",
  "dild0s",
  "dildo",
  "dildos",
  "dilf",
  "diligaf",
  "dilld0",
  "dilld0s",
  "dillweed",
  "dimwit",
  "dingle",
  "dingleberries",
  "dingleberry",
  "dink",
  "dinks",
  "dipship",
  "dipshit",
  "dipstick",
  "dirsa",
  "dirtypillows",
  "dirtysanchez",
  "dix",
  "dixiedike",
  "dixiedyke",
  "dlck",
  "dogstyle",
  "dog-fucker",
  "doggiestyle",
  "doggie",
  "doggie-style",
  "doggiestyle",
  "doggin",
  "dogging",
  "doggystyle",
  "doggy-style",
  "doggystyle",
  "dolcett",
  "domination",
  "dominatricks",
  "dominatrics",
  "dominatrix",
  "dommes",
  "dong",
  "donkeypunch",
  "donkeypunch",
  "donkeyribber",
  "doochbag",
  "doodoo",
  "doofus",
  "dookie",
  "doosh",
  "dothead",
  "dotheads",
  "dothead",
  "dotheads",
  "doubledong",
  "doublepenetration",
  "doubledong",
  "doublepenetration",
  "douch3",
  "douchebag",
  "douche",
  "douche-fag",
  "douchebag",
  "douchebags",
  "douchewaffle",
  "douchey",
  "dpaction",
  "dpaction",
  "dragqueen",
  "dragqween",
  "dripdick",
  "dryhump",
  "dryhump",
  "duche",
  "dudette",
  "dumass",
  "dumbass",
  "dumbass",
  "dumbasses",
  "dumbbitch",
  "dumbfuck",
  "dumbshit",
  "dumshit",
  "dunecoon",
  "dunecoons",
  "dupa",
  "dvda",
  "dyefly",
  "dyke",
  "dykes",
  "dziwka",
  "earotics",
  "easyslut",
  "eatmyass",
  "eatmy",
  "eatadick",
  "eatballs",
  "eathairpie",
  "eatme",
  "eatmyass",
  "eatpussy",
  "ecchi",
  "ejackulate",
  "ejakulate",
  "ekrem",
  "ekto",
  "enculer",
  "enema",
  "enlargement",
  "erect",
  "erection",
  "ero",
  "erotic",
  "erotism",
  "escort",
  "esqua",
  "essohbee",
  "ethicalslut",
  "evl",
  "excrement",
  "exkwew",
  "extacy",
  "extasy",
  "fucker",
  "fucke",
  "fuck",
  "fuk",
  "f*ck",
  "f-u-c-k",
  "f.u.c.k",
  "f4nny",
  "f_u_c_k",
  "facefucker",
  "fack",
  "faeces",
  "faen",
  "fag",
  "fag1t",
  "fagbag",
  "faget",
  "fagfucker",
  "fagg",
  "fagg1t",
  "fagged",
  "fagging",
  "faggit",
  "faggitt",
  "faggot",
  "faggotcock",
  "faggs",
  "fagit",
  "fagot",
  "fagots",
  "fags",
  "fagt",
  "fagtard",
  "fagz",
  "faig",
  "faigs",
  "faigt",
  "fanculo",
  "fannybandit",
  "fannyflaps",
  "fannyfucker",
  "fanyy",
  "fartknocker",
  "fastfuck",
  "fatah",
  "fatfuck",
  "fatfucker",
  "fatso",
  "fck",
  "fckcum",
  "fckd",
  "fcuk",
  "fcuker",
  "fcuking",
  "fecal",
  "feck",
  "fecker",
  "feg",
  "felatio",
  "felch",
  "felcher",
  "felching",
  "fellate",
  "fellatio",
  "feltch",
  "feltcher",
  "feltching",
  "femalesquirting",
  "femalesquirtin",
  "femalesquirting",
  "femdom",
  "fetish",
  "ficken",
  "figging",
  "fingerbang",
  "fingerfood",
  "fingerfuck",
  "fingerfucked",
  "fingerfucker",
  "fingerfuckers",
  "fingerfucking",
  "fingerfucks",
  "fingering",
  "fisted",
  "fister",
  "fistfuck",
  "fistfucked",
  "fistfucker",
  "fistfuckers",
  "fistfucking",
  "fistfuckings",
  "fistfucks",
  "fisting",
  "fisty",
  "fitt",
  "flamer",
  "flange",
  "flasher",
  "flikker",
  "flippingthebird",
  "flogthelog",
  "floo",
  "floozy",
  "flydie",
  "flydye",
  "foad",
  "fok",
  "fondle",
  "foobar",
  "fook",
  "fooker",
  "footfetish",
  "footaction",
  "footfetish",
  "footfuck",
  "footfucker",
  "footjob",
  "footlicker",
  "footstar",
  "foreskin",
  "forni",
  "fornicate",
  "fotze",
  "foursome",
  "fourtwenty",
  "freakfuck",
  "freakyfucker",
  "freefuck",
  "freex",
  "frigg",
  "frigga",
  "frigger",
  "frotting",
  "fucck",
  "fuck",
  "fuck-tard",
  "fucka",
  "fuckable",
  "fuckass",
  "fuckbag",
  "fuckbitch",
  "fuckbook",
  "fuckboy",
  "fuckbrain",
  "fuckbuddy",
  "fuckbutt",
  "fuckd",
  "fucked",
  "fuckedup",
  "fucker",
  "fuckers",
  "fuckersucker",
  "fuckface",
  "fuckfest",
  "fuckfreak",
  "fuckfriend",
  "fuckhead",
  "fuckheads",
  "fuckher",
  "fuckhole",
  "fuckin",
  "fuckina",
  "fucking",
  "fuckingbitch",
  "fuckings",
  "fuckingshitmotherfucker",
  "fuckinnuts",
  "fuckinright",
  "fuckit",
  "fuckknob",
  "fuckme",
  "fuckmeat",
  "fuckmehard",
  "fuckmonkey",
  "fuckn",
  "fucknugget",
  "fucknut",
  "fucknuts",
  "fucknutt",
  "fucknutz",
  "fuckoff",
  "fuckpig",
  "fuckpuppet",
  "fuckr",
  "fucks",
  "fuckstick",
  "fucktard",
  "fucktards",
  "fucktoy",
  "fucktrophy",
  "fuckup",
  "fuckwad",
  "fuckwhit",
  "fuckwhore",
  "fuckwit",
  "fuckwitt",
  "fuckyomama",
  "fuckyou",
  "fudgepacker",
  "fudgepacker",
  "fugly",
  "fuk",
  "fukah",
  "fuken",
  "fuker",
  "fukin",
  "fuking",
  "fukk",
  "fukkah",
  "fukken",
  "fukker",
  "fukkin",
  "fukking",
  "fuks",
  "fuktard",
  "fuktards",
  "fukwhit",
  "fukwit",
  "funfuck",
  "fungus",
  "futanari",
  "futanary",
  "futkretzn",
  "fuuck",
  "fux",
  "fux0r",
  "fuxor",
  "fvck",
  "fvk",
  "fxck",
  "g-spot",
  "g00k",
  "gae",
  "gai",
  "gangbang",
  "gangbang",
  "gangbanged",
  "gangbanger",
  "gangbangs",
  "gangsta",
  "ganja",
  "gassyass",
  "gatorbait",
  "gatorbait",
  "gaysex",
  "gayass",
  "gaybob",
  "gayboy",
  "gaydo",
  "gaygirl",
  "gaylord",
  "gaymuthafuckinwhore",
  "gays",
  "gaysex",
  "gaytard",
  "gaywad",
  "gayz",
  "geezer",
  "geni",
  "genital",
  "genitals",
  "getiton",
  "gey",
  "gfy",
  "ghay",
  "ghey",
  "giantcock",
  "gigolo",
  "ginzo",
  "ginzos",
  "gipp",
  "gippo",
  "gippos",
  "gipps",
  "girlontop",
  "girlon",
  "girlsgonewild",
  "givehead",
  "glans",
  "glazeddonut",
  "goatcx",
  "goatse",
  "gob",
  "goddammit",
  "goddamn",
  "goddamnit",
  "god-dam",
  "god-damned",
  "godam",
  "godammit",
  "godamn",
  "godamnit",
  "goddam",
  "goddamit",
  "goddamm",
  "goddammit",
  "goddamn",
  "goddamned",
  "goddamnes",
  "goddamnit",
  "goddamnmuthafucker",
  "godsdamn",
  "gokkun",
  "goldenshower",
  "goldenshower",
  "golliwog",
  "golliwogs",
  "gonad",
  "gonads",
  "gonorrehea",
  "gonzagas",
  "googirl",
  "gooch",
  "goodpoop",
  "gookeye",
  "gookeyes",
  "gook",
  "gookeye",
  "gookeyes",
  "gookies",
  "gooks",
  "gooky",
  "gora",
  "goras",
  "goregasm",
  "gotohell",
  "goy",
  "goyim",
  "greaseball",
  "greaseballs",
  "groe",
  "groid",
  "groids",
  "grope",
  "grostulation",
  "groupsex",
  "gspot",
  "gstring",
  "gtfo",
  "gub",
  "gubba",
  "gubbas",
  "gubs",
  "guido",
  "guiena",
  "guineas",
  "guizi",
  "gummer",
  "guro",
  "gwailo",
  "gwailos",
  "gweilo",
  "gweilos",
  "gyopo",
  "gyopos",
  "gyp",
  "gyped",
  "gypo",
  "gypos",
  "gypp",
  "gypped",
  "gyppie",
  "gyppies",
  "gyppo",
  "gyppos",
  "gyppy",
  "gyppys",
  "gypsys",
  "hell",
  "hom",
  "h00r",
  "h0ar",
  "h0m0",
  "h0mo",
  "h0r",
  "h0re",
  "h4x0r",
  "hadji",
  "hadjis",
  "hairyback",
  "hairybacks",
  "haji",
  "hajis",
  "hajji",
  "hajjis",
  "halfbreed",
  "halfcaste",
  "halfbreed",
  "halfcaste",
  "hamas",
  "hamflap",
  "handjob",
  "handjob",
  "haole",
  "haoles",
  "hapa",
  "hardcore",
  "hardcore",
  "hardcoresex",
  "hardon",
  "harem",
  "he11",
  "headfuck",
  "hebe",
  "hebes",
  "heeb",
  "heebs",
  "hell",
  "hells",
  "helvete",
  "hentai",
  "heroin",
  "herp",
  "herpes",
  "herpy",
  "heshe",
  "hijacker",
  "hijacking",
  "hillbillies",
  "hillbilly",
  "hindoo",
  "hiscock",
  "hitler",
  "hitlerism",
  "hitlerist",
  "hoar",
  "hoare",
  "hobag",
  "hodgie",
  "hoe",
  "hoer",
  "hoes",
  "holestuffer",
  "hom0",
  "homey",
  "homo",
  "homobangers",
  "homodumbshit",
  "homoey",
  "honger",
  "honkers",
  "honkey",
  "honkeys",
  "honkie",
  "honkies",
  "honky",
  "hooch",
  "hooker",
  "hookers",
  "hoor",
  "hoore",
  "hootch",
  "hooter",
  "hooters",
  "hore",
  "hori",
  "horis",
  "hork",
  "horndawg",
  "horndog",
  "horney",
  "horniest",
  "horny",
  "horseshit",
  "hosejob",
  "hoser",
  "hotcarl",
  "hotchick",
  "hotcarl",
  "hotdamn",
  "hotpussy",
  "hotsex",
  "hottotrot",
  "howtokill",
  "howtomurder",
  "howtokill",
  "howtomurdep",
  "huevon",
  "hugefat",
  "hugefat",
  "hui",
  "hummer",
  "humped",
  "humper",
  "humpher",
  "humphim",
  "humpin",
  "humping",
  "hussy",
  "hustler",
  "hymen",
  "hymie",
  "hymies",
  "iblowu",
  "ike",
  "ikes",
  "ikey",
  "ikeymo",
  "ikeymos",
  "ikwe",
  "illegal",
  "illegals",
  "inbred",
  "incest",
  "indon",
  "indons",
  "injun",
  "injuns",
  "insest",
  "intercourse",
  "interracial",
  "intheass",
  "inthebuff",
  "israels",
  "j3rk0ff",
  "jackoff",
  "jack-off",
  "jackass",
  "jackhole",
  "jackoff",
  "jackshit",
  "jacktheripper",
  "jailbait",
  "jailbait",
  "jap",
  "japcrap",
  "japie",
  "japies",
  "japs",
  "jebus",
  "jellydonut",
  "jerkoff",
  "jerk",
  "jerk-off",
  "jerk0ff",
  "jerked",
  "jerkoff",
  "jerries",
  "jerry",
  "jewboy",
  "jewed",
  "jewess",
  "jiga",
  "jigaboo",
  "jigaboos",
  "jigarooni",
  "jigaroonis",
  "jigg",
  "jigga",
  "jiggabo",
  "jiggaboo",
  "jiggabos",
  "jiggas",
  "jigger",
  "jiggerboo",
  "jiggers",
  "jiggs",
  "jiggy",
  "jigs",
  "jihad",
  "jijjiboo",
  "jijjiboos",
  "jimfish",
  "jisim",
  "jism",
  "jiss",
  "jiz",
  "jizim",
  "jizin",
  "jizjuice",
  "jizm",
  "jizn",
  "jizz",
  "jizzd",
  "jizzed",
  "jizzim",
  "jizzin",
  "jizzn",
  "jizzum",
  "jugg",
  "juggs",
  "jugs",
  "junglebunnies",
  "junglebunny",
  "junglebunny",
  "junkie",
  "junky",
  "kacap",
  "kacapas",
  "kacaps",
  "kaffer",
  "kaffir",
  "kaffre",
  "kafir",
  "kanake",
  "kanker",
  "katsap",
  "katsaps",
  "kawk",
  "khokhol",
  "khokhols",
  "kicking",
  "kigger",
  "kike",
  "kikes",
  "kimchis",
  "kinbaku",
  "kink",
  "kinkster",
  "kinky",
  "kinkyJesus",
  "kissass",
  "kiunt",
  "kkk",
  "klan",
  "klansman",
  "klansmen",
  "klanswoman",
  "klanswomen",
  "klootzak",
  "knobbing",
  "knobead",
  "knobed",
  "knobend",
  "knobhead",
  "knobjocky",
  "knobjokey",
  "knobz",
  "knockers",
  "knulle",
  "kock",
  "kondum",
  "kondums",
  "kooch",
  "kooches",
  "koon",
  "kootch",
  "krap",
  "krappy",
  "kraut",
  "krauts",
  "kuffar",
  "kuk",
  "kuksuger",
  "kum",
  "kumbubble",
  "kumbullbe",
  "kumer",
  "kummer",
  "kumming",
  "kumquat",
  "kums",
  "kunilingus",
  "kunnilingus",
  "kunt",
  "kunts",
  "kuntz",
  "kurac",
  "kurwa",
  "kushi",
  "kushis",
  "kusi",
  "kwa",
  "kwailo",
  "kwailos",
  "kwif",
  "kyke",
  "kykes",
  "kyopo",
  "kyopos",
  "kyrpa",
  "l3i+ch",
  "l3i\\+ch",
  "l3itch",
  "labia",
  "lapdance",
  "leatherrestraint",
  "leatherstraight",
  "leatherrestraint",
  "lebos",
  "lech",
  "lemonparty",
  "lemonparty",
  "leper",
  "lesbain",
  "lesbayn",
  "lesbin",
  "lesbo",
  "lesbos",
  "lez",
  "lezbe",
  "lezbefriends",
  "lezbian",
  "lezbians",
  "lezbo",
  "lezbos",
  "lezz",
  "lezzian",
  "lezzie",
  "lezzies",
  "lezzo",
  "lezzy",
  "libido",
  "licker",
  "licking",
  "lickme",
  "lilniglet",
  "limey",
  "limpdick",
  "limy",
  "lingerie",
  "lipshits",
  "lipshitz",
  "livesex",
  "loadedgun",
  "loin",
  "loins",
  "lolita",
  "lovebone",
  "lovegoo",
  "lovegun",
  "lovejuice",
  "lovemaking",
  "lovemuscle",
  "lovepistol",
  "loverocket",
  "lowlife",
  "lsd",
  "lubejob",
  "lubra",
  "lucifer",
  "luckycammeltoe",
  "lugan",
  "lugans",
  "lust",
  "lusting",
  "lusty",
  "lynch",
  "m-fucking",
  "m0f0",
  "m0fo",
  "m45terbate",
  "ma5terb8",
  "ma5terbate",
  "mabuno",
  "mabunos",
  "macaca",
  "macacas",
  "mafugly",
  "magicwand",
  "mahbuno",
  "mahbunos",
  "makemecome",
  "makemecome",
  "makemecum",
  "malesquirting",
  "mamhoon",
  "mams",
  "manhater",
  "manpaste",
  "maricon",
  "maricón",
  "marijuana",
  "masochist",
  "masokist",
  "massa",
  "massterbait",
  "masstrbait",
  "masstrbate",
  "mastabate",
  "mastabater",
  "master-bate",
  "masterb8",
  "masterbaiter",
  "masterbat",
  "masterbat3",
  "masterbate",
  "masterbates",
  "masterbating",
  "masterbation",
  "masterbations",
  "masterblaster",
  "mastrabator",
  "masturbat",
  "masturbate",
  "masturbating",
  "masturbation",
  "mattressprincess",
  "maumau",
  "maumaus",
  "maumau",
  "maumaus",
  "mcfagget",
  "meatbeatter",
  "meatrack",
  "menage",
  "merd",
  "mgger",
  "mggor",
  "mibun",
  "mick",
  "mickeyfinn",
  "mideast",
  "mierda",
  "milf",
  "minge",
  "minger",
  "mo-fo",
  "mockey",
  "mockie",
  "mocky",
  "mof0",
  "mofo",
  "moky",
  "molest",
  "molestation",
  "molester",
  "molestor",
  "moneyshot",
  "mong",
  "monkleigh",
  "moolie",
  "mooncricket",
  "mooncrickets",
  "mooncricket",
  "mooncrickets",
  "mormon",
  "moron",
  "moskal",
  "moskals",
  "moslem",
  "mosshead",
  "mothafucker",
  "mothafuker",
  "mothafukkah",
  "mothafukker",
  "mothafuck",
  "mothafucka",
  "mothafuckas",
  "mothafuckaz",
  "mothafucked",
  "mothafucker",
  "mothafuckers",
  "mothafuckin",
  "mothafucking",
  "mothafuckings",
  "mothafucks",
  "motherfucker",
  "motherfukah",
  "motherfuker",
  "motherfukkah",
  "motherfukker",
  "mother-fucker",
  "motherfuck",
  "motherfucka",
  "motherfucked",
  "motherfucker",
  "motherfuckers",
  "motherfuckin",
  "motherfucking",
  "motherfuckings",
  "motherfuckka",
  "motherfucks",
  "motherfvcker",
  "motherlovebone",
  "mothrfucker",
  "mouliewop",
  "moundofvenus",
  "moundofvenus",
  "mrhands",
  "mrhands",
  "mtherfucker",
  "mthrfuck",
  "mthrfucker",
  "mthrfucking",
  "mtrfck",
  "mtrfuck",
  "mtrfucker",
  "muffdiver",
  "muff",
  "muffdive",
  "muffdiver",
  "muffdiving",
  "muffindiver",
  "mufflikcer",
  "muffpuff",
  "muie",
  "mulatto",
  "mulkku",
  "muncher",
  "mung",
  "munging",
  "munt",
  "munter",
  "muschi",
  "muthafucker",
  "muthafukah",
  "muthafuker",
  "muthafukkah",
  "muthafukker",
  "muthafecker",
  "muthafuckaz",
  "muthafucker",
  "muthafuckker",
  "muther",
  "mutherfucker",
  "mutherfucking",
  "muthrfucking",
  "mzungu",
  "mzungus",
  "n1gga",
  "n1gger",
  "n1gr",
  "nad",
  "nads",
  "naked",
  "nambla",
  "nappy",
  "nastt",
  "nasty",
  "nastybitch",
  "nastyho",
  "nastyslut",
  "nastywhore",
  "nawashi",
  "nazi",
  "nazis",
  "nazism",
  "necked",
  "necro",
  "needthedick",
  "negres",
  "negress",
  "negro",
  "negroes",
  "negroid",
  "negros",
  "neonazi",
  "nepesaurio",
  "nignog",
  "nig",
  "niga",
  "nigar",
  "nigars",
  "nigas",
  "nigers",
  "nigette",
  "nigettes",
  "nigg",
  "nigg3r",
  "nigg4h",
  "nigga",
  "niggah",
  "niggahs",
  "niggar",
  "niggaracci",
  "niggard",
  "niggarded",
  "niggarding",
  "niggardliness",
  "niggardlinesss",
  "niggardly",
  "niggards",
  "niggars",
  "niggas",
  "niggaz",
  "nigger",
  "niggerhead",
  "niggerhole",
  "niggers",
  "niggle",
  "niggled",
  "niggles",
  "niggling",
  "nigglings",
  "niggor",
  "niggress",
  "niggresses",
  "nigguh",
  "nigguhs",
  "niggur",
  "niggurs",
  "niglet",
  "nignog",
  "nigor",
  "nigors",
  "nigr",
  "nigra",
  "nigras",
  "nigre",
  "nigres",
  "nigress",
  "nigs",
  "nigur",
  "niiger",
  "niigr",
  "nimphomania",
  "nimrod",
  "ninny",
  "nip",
  "nipple",
  "nipplering",
  "nipples",
  "nips",
  "nittit",
  "nlgger",
  "nlggor",
  "nobjokey",
  "nob",
  "nobhead",
  "nobjocky",
  "nobjokey",
  "nofuckingway",
  "nog",
  "nookey",
  "nookie",
  "nooky",
  "noonan",
  "nooner",
  "nsfwimages",
  "nsfw",
  "nudger",
  "nudie",
  "nudies",
  "numbnuts",
  "nutsack",
  "nutbutter",
  "nutfucker",
  "nutsack",
  "nutten",
  "nymph",
  "nympho",
  "nymphomania",
  "ock",
  "octopussy",
  "omorashi",
  "onecuptwogirls",
  "oneguyonejar",
  "oneguy",
  "onejar",
  "ontherag",
  "orafis",
  "orally",
  "orga",
  "orgasim",
  "orgasim;",
  "orgasims",
  "orgasm",
  "orgasmic",
  "orgasms",
  "orgasum",
  "orgies",
  "orgy",
  "oriface",
  "orifice",
  "orifiss",
  "orospu",
  "osama",
  "ovum",
  "ovums",
  "penis",
  "pis",
  "pussy",
  "p.u.s.s.y.",
  "p0rn",
  "packi",
  "packie",
  "packy",
  "paddy",
  "paedophile",
  "paki",
  "pakie",
  "pakis",
  "paky",
  "palesimian",
  "pancakeface",
  "pancakefaces",
  "panooch",
  "pansies",
  "pansy",
  "panti",
  "pantie",
  "panties",
  "panty",
  "paska",
  "pastie",
  "pasty",
  "payo",
  "pcp",
  "pearlnecklace",
  "pecker",
  "peckerhead",
  "peckerwood",
  "pedo",
  "pedobear",
  "pedophile",
  "pedophilia",
  "pedophiliac",
  "peeenus",
  "peeenusss",
  "peehole",
  "peenus",
  "peepee",
  "peepshow",
  "peepshpw",
  "pegging",
  "peinus",
  "pen1s",
  "penas",
  "pendejo",
  "pendy",
  "penetrate",
  "penetration",
  "peni5",
  "penial",
  "penile",
  "penis",
  "penis-breath",
  "penises",
  "penisfucker",
  "penisland",
  "penislick",
  "penislicker",
  "penispuffer",
  "penthouse",
  "penus",
  "penuus",
  "perse",
  "perv",
  "perversion",
  "peyote",
  "phalli",
  "phallic",
  "phonesex",
  "phonesex",
  "phuc",
  "phuck",
  "phuk",
  "phuked",
  "phuker",
  "phuking",
  "phukked",
  "phukker",
  "phukking",
  "phuks",
  "phungky",
  "phuq",
  "pi55",
  "picaninny",
  "piccaninny",
  "picka",
  "pickaninnies",
  "pickaninny",
  "pieceofshit",
  "pieceofshit",
  "piefke",
  "piefkes",
  "pierdol",
  "pigfucker",
  "piker",
  "pikey",
  "piky",
  "pillowbiter",
  "pillu",
  "pimmel",
  "pimp",
  "pimped",
  "pimper",
  "pimpis",
  "pimpjuic",
  "pimpjuice",
  "pimpsimp",
  "pindick",
  "pinko",
  "pis",
  "pises",
  "pisin",
  "pising",
  "pisof",
  "pisspig",
  "piss",
  "piss-off",
  "pissed",
  "pisser",
  "pissers",
  "pisses",
  "pissflap",
  "pissflaps",
  "pisshead",
  "pissin",
  "pissing",
  "pissoff",
  "pisspig",
  "pistol",
  "pizda",
  "playboy",
  "playgirl",
  "pleasurechest",
  "pleasurechest",
  "pocha",
  "pochas",
  "pocho",
  "pochos",
  "pocketpool",
  "pohm",
  "pohms",
  "polac",
  "polack",
  "polacks",
  "polak",
  "polesmoker",
  "polesmoker",
  "pollock",
  "pollocks",
  "pommiegrant",
  "pommiegrants",
  "pommy",
  "ponyplay",
  "poof",
  "poon",
  "poonani",
  "poonany",
  "poontang",
  "poontsee",
  "poopchute",
  "poopchute",
  "pooper",
  "pooperscooper",
  "pooping",
  "poorwhitetrash",
  "popimp",
  "porchmonkey",
  "porchmonkies",
  "porchmonkey",
  "porn",
  "pornflick",
  "pornking",
  "porno",
  "pornography",
  "pornos",
  "pornprincess",
  "poundtown",
  "poundtown",
  "pplicker",
  "pr0n",
  "pr1c",
  "pr1ck",
  "pr1k",
  "prairienigger",
  "prairieniggers",
  "premature",
  "preteen",
  "pric",
  "prickhead",
  "pricks",
  "prig",
  "princealbertpiercing",
  "pron",
  "prostitute",
  "pthc",
  "pu55i",
  "pu55y",
  "pube",
  "pubes",
  "pubic",
  "pubiclice",
  "pubis",
  "pud",
  "pudboy",
  "pudd",
  "puddboy",
  "puke",
  "pula",
  "pule",
  "punani",
  "punanny",
  "punany",
  "punkass",
  "punky",
  "punta",
  "puntang",
  "purinapricness",
  "pusies",
  "puss",
  "pusse",
  "pussee",
  "pussi",
  "pussie",
  "pussies",
  "pussy",
  "pussycat",
  "pussydestroyer",
  "pussyeater",
  "pussyfart",
  "pussyfucker",
  "pussylicker",
  "pussylicking",
  "pussylips",
  "pussylover",
  "pussypalace",
  "pussypounder",
  "pussys",
  "pusy",
  "puta",
  "puto",
  "puuke",
  "puuker",
  "qahbeh",
  "quashie",
  "queaf",
  "queef",
  "queerhole",
  "queero",
  "queers",
  "queerz",
  "quickie",
  "quicky",
  "quiff",
  "quim",
  "qweers",
  "qweerz",
  "qweir",
  "r-tard",
  "r-tards",
  "r5e",
  "ra8s",
  "raghead",
  "ragheads",
  "rape",
  "raped",
  "raper",
  "raping",
  "rapist",
  "rautenberg",
  "rearend",
  "rearentry",
  "recktum",
  "rectal",
  "rectum",
  "rectus",
  "redleg",
  "redlegs",
  "redlight",
  "redneck",
  "rednecks",
  "redskin",
  "redskins",
  "reefer",
  "reestie",
  "reetard",
  "reich",
  "renob",
  "rentafuck",
  "rere",
  "retard",
  "retarded",
  "retards",
  "retardz",
  "reversecowgirl",
  "reversecowgirl",
  "rigger",
  "rimjaw",
  "rimjob",
  "rimming",
  "ritard",
  "rosebuds",
  "rosypalmandher5sisters",
  "rosypalm",
  "rosypalm",
  "rosypalmandher5sisters",
  "rosypalmandherefivesisters",
  "roundeyes",
  "roundeye",
  "rtard",
  "rtards",
  "rumprammer",
  "ruski",
  "russki",
  "russkie",
  "rustytrombone",
  "rustytrombone",
  "shit",
  "shit",
  "s&m",
  "s-h-1-t",
  "s-h-i-t",
  "s-o-b",
  "s.h.i.t.",
  "s.o.b.",
  "s0b",
  "s_h_i_t",
  "sac",
  "sadis",
  "sadism",
  "sadist",
  "sadom",
  "sambo",
  "sambos",
  "samckdaddy",
  "sanchez",
  "sandnigger",
  "sandniggers",
  "sandm",
  "sandnigger",
  "santorum",
  "sausagequeen",
  "scag",
  "scallywag",
  "scank",
  "scantily",
  "scat",
  "schaffer",
  "scheiss",
  "schizo",
  "schlampe",
  "schlong",
  "schmuck",
  "schvartse",
  "schvartsen",
  "schwartze",
  "schwartzen",
  "scissoring",
  "screwed",
  "screwing",
  "screwyou",
  "scroat",
  "scrog",
  "scrote",
  "scrotum",
  "scrud",
  "seduce",
  "semen",
  "seppo",
  "seppos",
  "septics",
  "sex",
  "sexcam",
  "sexed",
  "sexfarm",
  "sexhound",
  "sexhouse",
  "sexi",
  "sexing",
  "sexkitten",
  "sexo",
  "sexpot",
  "sexslave",
  "sextogo",
  "sextoy",
  "sextoys",
  "sexual",
  "sexually",
  "sexwhore",
  "sexx",
  "sexxi",
  "sexxx",
  "sexxxi",
  "sexxxy",
  "sexxy",
  "sexy",
  "sexymoma",
  "sexyslim",
  "sh!+",
  "sh!t",
  "sh1t",
  "sh1ter",
  "sh1ts",
  "sh1tter",
  "sh1tz",
  "shag",
  "shagger",
  "shaggin",
  "shagging",
  "shamedame",
  "sharmuta",
  "sharmute",
  "shat",
  "shav",
  "shavedbeaver",
  "shavedpussy",
  "shavedbeaver",
  "shavedpussy",
  "shawtypimp",
  "sheeney",
  "shemale",
  "shhit",
  "shi+",
  "shibari",
  "shibary",
  "shinola",
  "shipal",
  "shitass",
  "shit",
  "shit-ass",
  "shit-bag",
  "shit-bagger",
  "shit-brain",
  "shit-breath",
  "shit-cunt",
  "shit-dick",
  "shit-eating",
  "shit-face",
  "shit-faced",
  "shit-fit",
  "shit-head",
  "shit-heel",
  "shit-hole",
  "shit-house",
  "shit-load",
  "shit-pot",
  "shit-spitter",
  "shit-stain",
  "shitass",
  "shitbag",
  "shitbagger",
  "shitblimp",
  "shitbrain",
  "shitbreath",
  "shitcan",
  "shitcunt",
  "shitdick",
  "shite",
  "shiteater",
  "shiteating",
  "shited",
  "shitey",
  "shitface",
  "shitfaced",
  "shitfit",
  "shitforbrains",
  "shitfuck",
  "shitfucker",
  "shitfull",
  "shithapens",
  "shithappens",
  "shithead",
  "shitheel",
  "shithole",
  "shithouse",
  "shiting",
  "shitings",
  "shitlist",
  "shitload",
  "shitola",
  "shitoutofluck",
  "shitpot",
  "shits",
  "shitspitter",
  "shitstain",
  "shitt",
  "shitted",
  "shitter",
  "shitters",
  "shittiest",
  "shitting",
  "shittings",
  "shitty",
  "shity",
  "shitz",
  "shiz",
  "shiznit",
  "shortfuck",
  "shota",
  "shrimping",
  "shylock",
  "shylocks",
  "shyt",
  "shyte",
  "shytty",
  "shyty",
  "simp",
  "sissy",
  "sixsixsix",
  "sixtynine",
  "sixtyniner",
  "skag",
  "skanck",
  "skank",
  "skankbitch",
  "skankee",
  "skankey",
  "skankfuck",
  "skanks",
  "skankwhore",
  "skanky",
  "skankybitch",
  "skankywhore",
  "skeet",
  "skinflute",
  "skribz",
  "skullfuck",
  "skum",
  "skumbag",
  "skurwysyn",
  "skwa",
  "skwe",
  "slag",
  "slanteye",
  "slanty",
  "slapper",
  "sleezeball",
  "slideitin",
  "slimeball",
  "slimebucket",
  "slopehead",
  "slopeheads",
  "sloper",
  "slopers",
  "slopes",
  "slopey",
  "slopeys",
  "slopies",
  "slopy",
  "slut",
  "slutbag",
  "slutbucket",
  "slutdumper",
  "slutkiss",
  "sluts",
  "slutt",
  "slutting",
  "slutty",
  "slutwear",
  "slutwhore",
  "slutz",
  "smack",
  "smackthemonkey",
  "smeg",
  "smegma",
  "smoker",
  "smut",
  "smutty",
  "snatchpatch",
  "snigger",
  "sniggered",
  "sniggering",
  "sniggers",
  "snowback",
  "snowballing",
  "snownigger",
  "snuff",
  "socksucker",
  "sodom",
  "sodomise",
  "sodomite",
  "sodomize",
  "sodomy",
  "sonofabitch",
  "sonofawhore",
  "son-of-a-bitch",
  "son-of-a-whore",
  "sonofabitch",
  "sonofbitch",
  "sooties",
  "sooty",
  "souse",
  "soused",
  "soyboy",
  "spac",
  "spade",
  "spades",
  "spaghettibender",
  "spaghettinigger",
  "spank",
  "spankthemonkey",
  "spastic",
  "spearchucker",
  "spearchuckers",
  "sperm",
  "spermacide",
  "spermbag",
  "spermhearder",
  "spermherder",
  "sphencter",
  "spic",
  "spick",
  "spicks",
  "spics",
  "spierdalaj",
  "spig",
  "spigotty",
  "spik",
  "spiks",
  "spitter",
  "splittail",
  "splooge",
  "spludge",
  "spooge",
  "spreadlegs",
  "spreadeagle",
  "spunk",
  "spunky",
  "sqeh",
  "squa",
  "squarehead",
  "squareheads",
  "squaw",
  "squinty",
  "squirting",
  "stagg",
  "steamy",
  "stfu",
  "stiffy",
  "stoned",
  "stoner",
  "strapon",
  "strapon",
  "strappado",
  "stringer",
  "stripclub",
  "stripclub",
  "stroke",
  "stroking",
  "stuinties",
  "stupidfuck",
  "stupidfucker",
  "styledoggy",
  "suckdick",
  "sucked",
  "sucker",
  "sucking",
  "suckme",
  "suckmyass",
  "suckmydick",
  "suckmytit",
  "suckoff",
  "sucks",
  "suicidegirl",
  "suicidegirls",
  "suicidegirl",
  "suicidegirls",
  "suka",
  "sultrywoman",
  "sultrywomen",
  "sumofabiatch",
  "swallower",
  "swalow",
  "swampguinea",
  "swampguineas",
  "swastika",
  "syphilis",
  "tit",
  "tits",
  "t1t",
  "t1tt1e5",
  "t1tties",
  "taboo",
  "tacohead",
  "tacoheads",
  "taff",
  "takeoffyour",
  "tarbabies",
  "tarbaby",
  "tarbaby",
  "tard",
  "tastemy",
  "tastemy",
  "tawdry",
  "teabagging",
  "teabagging",
  "teat",
  "teets",
  "teez",
  "terd",
  "terror",
  "terrorist",
  "teste",
  "testee",
  "testes",
  "testical",
  "testicle",
  "testicles",
  "testis",
  "thicklip",
  "thicklips",
  "thirdeye",
  "thirdleg",
  "threesome",
  "threeway",
  "throating",
  "thumbzilla",
  "thundercunt",
  "tiedup",
  "tigolbitties",
  "tigoldbitties",
  "tightwhite",
  "timbernigger",
  "timberniggers",
  "timbernigger",
  "tinkle",
  "tit",
  "titbitnipply",
  "titfuck",
  "titfucker",
  "titfuckin",
  "titi",
  "titjob",
  "titlicker",
  "titlover",
  "tits",
  "titt",
  "tittie",
  "tittie5",
  "tittiefucker",
  "titties",
  "tittis",
  "titty",
  "tittyfuck",
  "tittyfucker",
  "tittys",
  "tittywank",
  "titwank",
  "tity",
  "tomurder",
  "toke",
  "tongethruster",
  "tongueina",
  "tongueina",
  "tonguethrust",
  "tonguetramp",
  "toots",
  "topless",
  "tortur",
  "torture",
  "tosser",
  "towelhead",
  "towelheads",
  "towelhead",
  "trailertrash",
  "tramp",
  "trannie",
  "tranny",
  "transsexual",
  "transvestite",
  "trashy",
  "tribadism",
  "triplex",
  "trisexual",
  "trois",
  "trojan",
  "trots",
  "tubgirl",
  "tubgirl",
  "tuckahoe",
  "tunneloflove",
  "turdburgler",
  "turnon",
  "tush",
  "tushy",
  "tw4t",
  "twat",
  "twathead",
  "twatlips",
  "twats",
  "twatty",
  "twatwaffle",
  "twink",
  "twinkie",
  "twogirlsonecup",
  "twobitwhore",
  "twunt",
  "twunter",
  "udgepacker",
  "ukrop",
  "unclefucker",
  "undressing",
  "unfuckable",
  "upskirt",
  "uptheass",
  "upthebutt",
  "urethraplay",
  "urethraplay",
  "urophilia",
  "usama",
  "ussys",
  "uzi",
  "vagina",
  "v14gra",
  "v1gra",
  "v4gra",
  "va-j-j",
  "va1jina",
  "vag",
  "vag1na",
  "vagiina",
  "vaj1na",
  "vajina",
  "valium",
  "venusmound",
  "vgra",
  "vibr",
  "vibrater",
  "vibrator",
  "vigra",
  "violetwand",
  "virgin",
  "virginbreaker",
  "vittu",
  "vixen",
  "vjayjay",
  "vodka",
  "vomit",
  "vorarephilia",
  "voyeurweb",
  "voyuer",
  "vullva",
  "vulva",
  "w00se",
  "w0p",
  "wab",
  "wad",
  "wang",
  "wank",
  "wanker",
  "wanking",
  "wanky",
  "waysted",
  "wazoo",
  "weenie",
  "weewee",
  "weiner",
  "welcher",
  "wench",
  "wetdream",
  "wetb",
  "wetback",
  "wetbacks",
  "wetdream",
  "wetspot",
  "wh00r",
  "wh0re",
  "wh0reface",
  "whacker",
  "whash",
  "whigger",
  "whiggers",
  "whiskeydick",
  "whiskydick",
  "whit",
  "whitepower",
  "whitetrash",
  "whitenigger",
  "whitepower",
  "whites",
  "whitetrash",
  "whitey",
  "whiteys",
  "whities",
  "whoar",
  "whop",
  "whoralicious",
  "whore",
  "whorealicious",
  "whorebag",
  "whored",
  "whoreface",
  "whorefucker",
  "whorehopper",
  "whorehouse",
  "whores",
  "whoring",
  "wichser",
  "wigga",
  "wiggas",
  "wigger",
  "wiggers",
  "willie",
  "willies",
  "williewanker",
  "willy",
  "wog",
  "wogs",
  "woose",
  "wop",
  "worldsex",
  "wrappingmen",
  "wrinkledstarfish",
  "wtf",
  "wuss",
  "wuzzie",
  "x-rated",
  "x-rated2g1c",
  "xkwe",
  "xrated",
  "xtc",
  "xx",
  "xxx",
  "xxxxxx",
  "yank",
  "yaoi",
  "yarpie",
  "yarpies",
  "yeasty",
  "yed",
  "yellowshowers",
  "yellowman",
  "yellowshowers",
  "yid",
  "yids",
  "yiffy",
  "yobbo",
  "yourboobs",
  "yourpenis",
  "yourtits",
  "yury",
  "zabourah",
  "zigabo",
  "zigabos",
  "zipperhead",
  "zipperheads",
  "zoophile",
  "zoophilia",
  "🖕",
  "Ahlainen",
  "Akaa",
  "Alajärvi",
  "Alastaro",
  "Alaveteli",
  "Alavieska",
  "Alavus",
  "Anttola",
  "Asikkala",
  "Askola",
  "Aura",
  "Brändö",
  "Eckerö",
  "Enonkoski",
  "Enontekiö",
  "Espoo",
  "Eura",
  "Eurajoki",
  "Evijärvi",
  "Fiskars",
  "Finström",
  "Forssa",
  "Föglö",
  "Geta",
  "Haapajärvi",
  "Haapaluoma",
  "Haapavesi",
  "Hailuoto",
  "Halsua",
  "Hamina",
  "Hammarland",
  "Hankasalmi",
  "Hanko",
  "Harjavalta",
  "Hartola",
  "Hattula",
  "Hausjärvi",
  "Heinola",
  "Heinävesi",
  "Helsinki",
  "Herrala",
  "Himanka",
  "Hirvensalmi",
  "Hollola",
  "Honkajoki",
  "Huittinen",
  "Humppila",
  "Hyrynsalmi",
  "Hyvinkää",
  "Hämeenkoski",
  "Hämeenkyrö",
  "Hämeenlinna",
  "Ii",
  "Iisalmi",
  "Iitti",
  "Ikaalinen",
  "Ilmajoki",
  "Ilomantsi",
  "Imatra",
  "Inari",
  "Inkoo",
  "Isojoki",
  "Isokyrö",
  "Jakobstad",
  "Jalasjärvi",
  "Janakkala",
  "Joensuu",
  "Jokela",
  "Jokioinen",
  "Jomala",
  "Joroinen",
  "Jorvas",
  "Joutsa",
  "Juankoski",
  "Juornaankylä",
  "Juuka",
  "Juupajoki",
  "Juva",
  "Jyväskylä",
  "Jämijärvi",
  "Jämsä",
  "Järvenpää",
  "Kaaresuvanto",
  "Kaarina",
  "Kaavi",
  "Kajaani",
  "Kalajoki",
  "Kangasala",
  "Kangasniemi",
  "Kankaanpää",
  "Kannus",
  "Karijoki",
  "Karjalohja",
  "Karkkila",
  "Karstula",
  "Karttula",
  "Karvia",
  "Kaskinen",
  "Kauhajoki",
  "Kauhava",
  "Kauniainen",
  "Kausala",
  "Kaustinen",
  "Keitele",
  "Kellokoski",
  "Kemi",
  "Kemijärvi",
  "Keminmaa",
  "Kemiönsaari",
  "Kempele",
  "Kerava",
  "Kerkonjoensuu",
  "Keuruu",
  "Kihniö",
  "Kiikala",
  "Kiiminki",
  "Kinnula",
  "Kirkkonummi",
  "Kitee",
  "Kittilä",
  "Kiuruvesi",
  "Kivijärvi",
  "Kiviniemi",
  "Klaukkala",
  "Kokemäki",
  "Kokkola",
  "Kolari",
  "Konnevesi",
  "Kontiolahti",
  "Korpilahti",
  "Korsholm",
  "KoskiTl",
  "Kotalahti",
  "Kotka",
  "Kouvola",
  "Kristiinankaupunki",
  "Kruunupyy",
  "Kuhmo",
  "Kuopio",
  "Kuortane",
  "Kurikka",
  "Kuru",
  "Kustavi",
  "Kuusa",
  "Kuusamo",
  "Kuusankoski",
  "Kylmälä",
  "Kyyjärvi",
  "Kälviä",
  "Kärkölä",
  "Kärsämäki",
  "Kökar",
  "Lahela",
  "Lahti",
  "Laihia",
  "Laitila",
  "Lammi",
  "Lapinjärvi",
  "Lapinlahti",
  "Lappajärvi",
  "Lappeenrannanseutukunta",
  "Lappeenranta",
  "Lapua",
  "Larsmo",
  "Laukaa",
  "Launonen",
  "Lavia",
  "Lemi",
  "Lemland",
  "Lempäälä",
  "Leppävirta",
  "Lestijärvi",
  "Lieksa",
  "Lieto",
  "Liminka",
  "Linnantaus",
  "Liperi",
  "Littoinen",
  "Lohja",
  "Loimaa",
  "Loppi",
  "Loviisa",
  "Luhanka",
  "Lumijoki",
  "Lumparland",
  "Luosto",
  "Luoto",
  "Luumäki",
  "Luvia",
  "Maalahti",
  "Maarianhamina",
  "Marttila",
  "Masku",
  "Merijärvi",
  "Merikarvia",
  "Miehikkälä",
  "Mikkeli",
  "Muhos",
  "Multia",
  "Muonio",
  "Mustasaari",
  "Muurame",
  "Muuruvesi",
  "Mynämäki",
  "Myrskylä",
  "Mäntsälä",
  "Mänttä",
  "Mänttä-Vilppula",
  "Mäntyharju",
  "Naantali",
  "Naarajärvi",
  "Nakkila",
  "Nastola",
  "Nilsiä",
  "Nivala",
  "Nokia",
  "Noormarkku",
  "Nousiainen",
  "Nummela",
  "Nurmes",
  "Nurmijärvi",
  "Nurmo",
  "Närpes",
  "Orimattila",
  "Oripää",
  "Orivesi",
  "Oulainen",
  "Oulu",
  "Oulunsalo",
  "Padasjoki",
  "Paimio",
  "Palokka",
  "Paltamo",
  "Parainen",
  "Parikkala",
  "Parkano",
  "Pattijoki",
  "Pedersörenkunta",
  "Pelkosenniemi",
  "Pello",
  "Perho",
  "Pertunmaa",
  "Petäjävesi",
  "Pieksämäki",
  "Pielavesi",
  "Pietarsaari",
  "Pihtipudas",
  "Pirkkala",
  "Polvijärvi",
  "Pomarkku",
  "Pori",
  "Pornainen",
  "Porvoo",
  "Posio",
  "Pudasjärvi",
  "Pukkila",
  "Punkalaidun",
  "Puolanka",
  "Puumala",
  "Pyhtää",
  "Pyhäjoki",
  "Pyhäjärvi",
  "Pyhäntä",
  "Pyhäranta",
  "Pälkäne",
  "Pöytyä",
  "Raahe",
  "Raisio",
  "Rantasalmi",
  "Ranua",
  "Rauma",
  "Rautalampi",
  "Rautavaara",
  "Rautjärvi",
  "Reisjärvi",
  "Reitkalli",
  "Renko",
  "Riihimäki",
  "Ristijärvi",
  "Rovaniemi",
  "Ruokolahti",
  "Ruovesi",
  "Rusko",
  "Rääkkylä",
  "Röykkä",
  "Saarenkylä",
  "Saarijärvi",
  "Salla",
  "Salo",
  "Saltvik",
  "Sastamala",
  "Sauvo",
  "Saukkola",
  "Savitaipale",
  "Savonlinna",
  "Savukoski",
  "Seinäjoki",
  "Sievi",
  "Siikainen",
  "Siikajoki",
  "Siilinjärvi",
  "Simo",
  "Sinettä",
  "Sipoo",
  "Siuntio",
  "Sodankylä",
  "Soini",
  "Somero",
  "Sonkajärvi",
  "Sotkamo",
  "Sottunga",
  "Sulkava",
  "Sund",
  "Suolahti",
  "Suomenniemi",
  "Suomussalmi",
  "Suonenjoki",
  "Suinula",
  "Sysmä",
  "Säkylä",
  "Säynätsalo",
  "Taipalsaari",
  "Taivalkoski",
  "Taivassalo",
  "Tammela",
  "Tampere",
  "Tervakoski",
  "Tervola",
  "Teuva",
  "Tohmajärvi",
  "Toholampi",
  "Toivakka",
  "Toivala",
  "Tornio",
  "Turenki",
  "Turku",
  "Tuusniemi",
  "Tuusula",
  "Tyrnävä",
  "Töysä",
  "Uki",
  "Ulvila",
  "Urjala",
  "Utajärvi",
  "Utsjoki",
  "Uurainen",
  "Uusikaarlepyy",
  "Uusikaupunki",
  "Vaala",
  "Vaasa",
  "Valkeakoski",
  "Vantaa",
  "Varkaus",
  "Vehmaa",
  "Vesanto",
  "Vesilahti",
  "Veteli",
  "Vieremä",
  "Vihanti",
  "Vihti",
  "Viitasaari",
  "Vikby",
  "Villähde",
  "Vilppula",
  "Vimpeli",
  "Virolahti",
  "Virrat",
  "Vuojalahti",
  "Vääksy",
  "Vårdö",
  "Ylihärmä",
  "Ylitornio",
  "Ylivieska",
  "Ylöjärvi",
  "Ypäjä",
  "Äänekoski"
];
